var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39893 3.20002V16.4C7.39893 16.9835 7.63071 17.543 8.04329 17.9556C8.45587 18.3682 9.01545 18.6 9.59893 18.6H18.3989C18.9824 18.6 19.5419 18.3682 19.9545 17.9556C20.3672 17.543 20.5989 16.9835 20.5989 16.4V6.76622C20.5989 6.47313 20.5403 6.18301 20.4266 5.91288C20.3128 5.64276 20.1463 5.39808 19.9367 5.19322L16.2902 1.62702C15.8793 1.22514 15.3273 1.00009 14.7524 1.00002H9.59893C9.01545 1.00002 8.45587 1.2318 8.04329 1.64438C7.63071 2.05696 7.39893 2.61654 7.39893 3.20002Z",
    stroke: "#95A3B5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.199 18.6V20.8C16.199 21.3835 15.9673 21.943 15.5546 22.3556C15.142 22.7682 14.5825 23 13.999 23H5.19902C4.61555 23 4.05597 22.7682 3.64339 22.3556C3.2308 21.943 2.99902 21.3835 2.99902 20.8V8.70002C2.99902 8.11654 3.2308 7.55696 3.64339 7.14438C4.05597 6.7318 4.61555 6.50002 5.19902 6.50002H7.39902",
    stroke: "#95A3B5",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.b6c3d641719935ed38da9a5210ddbe82.svg";
export { ForwardRef as ReactComponent };